import { render, staticRenderFns } from "./detail-freepurchase.vue?vue&type=template&id=749fe235&"
import script from "./detail-freepurchase.vue?vue&type=script&lang=js&"
export * from "./detail-freepurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports